var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_247_21209)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5714 0.144531C12.9972 0.144531 6.85714 6.28463 6.85714 13.8588C6.85714 14.2402 6.87275 14.6182 6.90341 14.9923C2.82576 16.9081 0 21.0516 0 25.8588C0 32.4862 5.37258 37.8588 12 37.8588H37.7143C43.3949 37.8588 48 33.2537 48 27.5731C48 23.7223 45.8844 20.3688 42.7561 18.6062C42.8227 18.1757 42.8571 17.7352 42.8571 17.2874C42.8571 12.5535 39.0196 8.71596 34.2857 8.71596C33.9563 8.71596 33.6309 8.73462 33.3104 8.771C31.2899 3.7167 26.3496 0.144531 20.5714 0.144531ZM25.2122 12.6466C24.5427 11.9772 23.4573 11.9772 22.7878 12.6466L15.9307 19.5038C15.2612 20.1732 15.2612 21.2587 15.9307 21.9281C16.6001 22.5976 17.6856 22.5976 18.355 21.9281L22.2857 17.9975L22.2857 29.2874C22.2857 30.2342 23.0532 31.0017 24 31.0017C24.9468 31.0017 25.7143 30.2342 25.7143 29.2874V17.9975L29.645 21.9281C30.3144 22.5976 31.3999 22.5976 32.0693 21.9281C32.7388 21.2587 32.7388 20.1732 32.0693 19.5038L25.2122 12.6466Z",
    fill: "#8199F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_247_21209",
    x: 0,
    y: 0.144531,
    width: 48,
    height: 39.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_247_21209"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4d279b366025a304c0d8ef4dfb12c400.svg";
export { ForwardRef as ReactComponent };